"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 公共
var GlobalMethodClass = /*#__PURE__*/function () {
  function GlobalMethodClass() {
    (0, _classCallCheck2.default)(this, GlobalMethodClass);
    (0, _defineProperty2.default)(this, "isSSR", void 0);
    (0, _defineProperty2.default)(this, "consoleErrorInfo", void 0);
    this.isSSR = typeof window === 'undefined';
    this.consoleErrorInfo = {};
  }
  (0, _createClass2.default)(GlobalMethodClass, [{
    key: "mergeConsoleErrorInfo",
    value: function mergeConsoleErrorInfo(target) {
      this.consoleErrorInfo = _objectSpread(_objectSpread({}, this.consoleErrorInfo || {}), target || {});
    }
  }, {
    key: "initGlobalEvent",
    value: function initGlobalEvent() {
      var _this = this;
      if (!this.isSSR) {
        window.addEventListener('unhandledrejection', function (event) {
          var _event$reason, _event$reason2;
          // console.log('----unhandledrejection error: ', event)
          // 静态资源加载失败
          if (event && (event === null || event === void 0 || (_event$reason = event.reason) === null || _event$reason === void 0 ? void 0 : _event$reason.name) === 'ChunkLoadError' && (event === null || event === void 0 || (_event$reason2 = event.reason) === null || _event$reason2 === void 0 ? void 0 : _event$reason2.type) === 'error') {
            _this.mergeConsoleErrorInfo({
              hasChunkLoadError: true
            });
          }
          if (event && event !== null && event !== void 0 && event.reason) {
            var _event$reason3, _event$reason4;
            var message = (event === null || event === void 0 || (_event$reason3 = event.reason) === null || _event$reason3 === void 0 ? void 0 : _event$reason3.stack) || (event === null || event === void 0 || (_event$reason4 = event.reason) === null || _event$reason4 === void 0 ? void 0 : _event$reason4.message) || (event === null || event === void 0 ? void 0 : event.reason);
            var currInfo = {
              message: message
            };
            _this.logger({
              title: 'Sentry捕获错误信息',
              message: currInfo
            });
            _this.mergeConsoleErrorInfo({
              'Sentry捕获错误信息': currInfo
            });
          }
        });
        window.addEventListener('error', function (event) {
          // console.log('----addEventListener error: ', event)
          try {
            var target = (event === null || event === void 0 ? void 0 : event.target) || (event === null || event === void 0 ? void 0 : event.srcElement);
            if (target instanceof HTMLScriptElement || target instanceof HTMLLinkElement) {
              var src = (target === null || target === void 0 ? void 0 : target.src) || (target === null || target === void 0 ? void 0 : target.href);
              if (src) {
                _this.mergeConsoleErrorInfo((0, _defineProperty2.default)({
                  hasChunkLoadError: true
                }, '加载失败的资源_' + new Date().getTime(), {
                  url: src,
                  nodeName: target === null || target === void 0 ? void 0 : target.nodeName
                }));
              }
            }
          } catch (e) {
            _this.logger(JSON.stringify(e));
          }
          if (event && event !== null && event !== void 0 && event.message) {
            var _event$error, _event$error2;
            var errorInfo = {
              message: event === null || event === void 0 ? void 0 : event.message,
              error: event !== null && event !== void 0 && event.error ? JSON.stringify({
                message: event === null || event === void 0 || (_event$error = event.error) === null || _event$error === void 0 ? void 0 : _event$error.message,
                stack: event === null || event === void 0 || (_event$error2 = event.error) === null || _event$error2 === void 0 ? void 0 : _event$error2.stack
              }) : '无',
              filename: event === null || event === void 0 ? void 0 : event.filename,
              type: event === null || event === void 0 ? void 0 : event.type,
              lineno: event === null || event === void 0 ? void 0 : event.lineno
            };
            _this.mergeConsoleErrorInfo({
              '控制台错误信息': errorInfo
            });
            _this.logger(JSON.stringify(errorInfo));
          }
        }, true);
      }
    }
  }, {
    key: "logger",
    value: function logger(info) {
      if (info && console) {
        var title = typeof info === 'string' ? '' : (info === null || info === void 0 ? void 0 : info.title) || '';
        var message = typeof info === 'string' ? info : (info === null || info === void 0 ? void 0 : info.message) || '';
        if (typeof info === 'string' && info) {
          console.log('Sentry日志打印-', info);
        } else if (title && message) {
          console.log("".concat(title, "\uFF1A"), message);
        } else if (!title && message) {
          console.log('Sentry日志打印-', message);
        }
      }
    }
  }]);
  return GlobalMethodClass;
}();
var _default = exports.default = GlobalMethodClass;